export class QueryContainer {
  currentQueryPlaceholder: string = undefined;
  defaultQueryTooltip: string;
  query: string = undefined;
  queryField: string = undefined;
  queryPlaceholder: string;
  selectedQueryMenu: any;
}
